import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function TermsPage() {
  return (
    <div className="min-h-screen bg-[var(--color-bg)] p-4">
      <div className="mx-auto max-w-2xl">
        <Link
          to="/help"
          className="mb-6 flex items-center gap-2 text-sm text-[var(--color-muted)] hover:text-[var(--color-text)]"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to help
        </Link>

        <div className="mb-8">
          <h1 className="text-2xl font-bold">Terms of Service</h1>
          <p className="mt-1 text-[var(--color-muted)]">Last updated: January 2025</p>
        </div>

        <div className="space-y-6 text-[var(--color-text)]">
          <section>
            <h2 className="mb-2 text-lg font-semibold">1. Acceptance of Terms</h2>
            <p className="text-[var(--color-muted)]">
              By accessing or using Bar Guide ("the Service"), you agree to be bound by these
              Terms of Service. If you do not agree to these terms, please do not use the
              Service.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold">2. Description of Service</h2>
            <p className="text-[var(--color-muted)]">
              Bar Guide is a platform that aggregates and displays bar specials, happy hours,
              and events from establishments in your area. We use automated systems to gather
              this information from publicly available sources.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold">3. Information Accuracy</h2>
            <p className="text-[var(--color-muted)]">
              While we strive to provide accurate and up-to-date information, bar specials
              and events may change without notice. We do not guarantee the accuracy,
              completeness, or timeliness of any information displayed on the Service.{' '}
              <strong>
                Always verify specials and events directly with the establishment before
                visiting.
              </strong>
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold">4. User Accounts</h2>
            <p className="text-[var(--color-muted)]">
              You may create an account to access additional features such as saving
              favorites. You are responsible for maintaining the security of your account
              credentials and for all activities that occur under your account.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold">5. User Submissions</h2>
            <p className="text-[var(--color-muted)]">
              If you submit bars or other content to the Service, you represent that you have
              the right to share such information and that it is accurate to the best of your
              knowledge.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold">6. Prohibited Conduct</h2>
            <p className="mb-2 text-[var(--color-muted)]">You agree not to:</p>
            <ul className="list-disc space-y-1 pl-5 text-[var(--color-muted)]">
              <li>Use the Service for any unlawful purpose</li>
              <li>Attempt to gain unauthorized access to any part of the Service</li>
              <li>Interfere with or disrupt the Service</li>
              <li>Scrape or harvest data from the Service without permission</li>
              <li>Submit false or misleading information</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold">7. Intellectual Property</h2>
            <p className="text-[var(--color-muted)]">
              The Service and its original content, features, and functionality are owned by
              Bar Guide and are protected by applicable intellectual property laws.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold">8. Disclaimer of Warranties</h2>
            <p className="text-[var(--color-muted)]">
              THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY
              KIND, EITHER EXPRESS OR IMPLIED. WE DO NOT WARRANT THAT THE SERVICE WILL BE
              UNINTERRUPTED, SECURE, OR ERROR-FREE.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold">9. Limitation of Liability</h2>
            <p className="text-[var(--color-muted)]">
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, BAR GUIDE SHALL NOT BE LIABLE FOR ANY
              INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM
              YOUR USE OF THE SERVICE, INCLUDING BUT NOT LIMITED TO RELIANCE ON INFORMATION
              DISPLAYED ON THE SERVICE.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold">10. Changes to Terms</h2>
            <p className="text-[var(--color-muted)]">
              We reserve the right to modify these Terms at any time. Continued use of the
              Service after changes constitutes acceptance of the modified Terms.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold">11. Contact</h2>
            <p className="text-[var(--color-muted)]">
              For questions about these Terms, please contact us at{' '}
              <a
                href="mailto:privacy@mouserlabs.com"
                className="text-accent-primary hover:underline"
              >
                privacy@mouserlabs.com
              </a>
              .
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
